import React from 'react';
import { PolarArea } from 'react-chartjs-2';
import { polarDefaults } from '../../utils/chartDefaults';
import { deepMerge, getChartColors, hexToRgba, isMissingColor } from '../../utils/chartHelpers';
import type { ChartDataLike } from '../../utils/chartHelpers';
import ChartFrame from './ChartFrame';

const applyPolarTheme = (data: ChartDataLike): ChartDataLike => {
    if (!data || !Array.isArray(data.datasets) || data.datasets.length === 0) return data;
    const labelsLength = Array.isArray(data.labels) ? data.labels.length : 0;
    const datasets = data.datasets.map((ds) => {
        const next: any = { ...ds };
        if (isMissingColor(ds.backgroundColor)) {
            const base = getChartColors(Math.max(1, labelsLength));
            next.backgroundColor = base.map((hex, idx) => hexToRgba(hex, 0.9 - idx * 0.1));
        }
        return next;
    });
    return { ...data, datasets };
};

export interface PolarAreaChartProps {
    data: ChartDataLike;
    options?: any;
    className?: string;
    title?: string;
    badge?: string;
}

const PolarAreaChart: React.FC<PolarAreaChartProps> = ({ data, options, className, title, badge }) => {
    const merged = React.useMemo(() => deepMerge(polarDefaults, options || {}), [options]);
    const themed = React.useMemo(() => applyPolarTheme(data), [data]);
    return (
        <ChartFrame title={title} badge={badge} className={className}>
            <PolarArea data={themed as any} options={merged} />
        </ChartFrame>
    );
};

export default PolarAreaChart;
